import React, { useEffect, useState } from "react";

/* Config */
import config from "../../app/config.json";

/* Components */
import {
  Container,
  LoadingScreen,
  PaginationControls,
  RefreshRateSlider,
} from "../../utils/components/Common";

/* APIs - Hooks - Utils */
import { useAppSelector } from "../../app/hooks";
import { DashboardCard } from "./Dashboard.elements";
import { useListStatusesQuery } from "./dashboardApi";
import { toastQueryError } from "../../utils/toasts";

const Dashboard = (): JSX.Element => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const user = useAppSelector((state) => state.user.user);
  const [processing, setProcessing] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(
    config.constants.pagination.pageSize
  );
  const [pollingInterval, setPollingInterval] = useState(
    config.constants.refreshRate.maxPollingInterval / 2
  );
  const {
    data: statuses,
    error,
    isFetching,
    isError,
    isLoading,
    refetch,
  } = useListStatusesQuery(
    { page: page, page_size: pageSize },
    { pollingInterval: pollingInterval }
  );

  const onPageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(parseInt(e.target.value));
    setPage(1);
  };

  const onRefetchRateSliderChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPollingInterval(parseInt(e.target.value));
  };

  useEffect(() => {
    if (error) {
      toastQueryError(error);
    }
  }, [isError]);

  useEffect(() => {
    if (isFetching || isLoading) {
      setProcessing(true);
    } else {
      setProcessing(false);
    }
    if (isError && error) {
      toastQueryError(error);
    }
  }, [isLoading, isFetching]);

  return (
    <>
      {processing ? <LoadingScreen /> : null}

      {user && isLoggedIn ? (
        <>
          <PaginationControls
            paginatedResponse={statuses}
            setPage={setPage}
            refetch={refetch}
            onPageSizeChange={onPageSizeChange}
          />

          <RefreshRateSlider
            pollingInterval={pollingInterval}
            onRefreshSliderChange={onRefetchRateSliderChange}
          />

          <Container
            flex="flex"
            flexWrap="flex-wrap"
            justifyContent="justify-center"
            margin="mt-10"
          >
            {statuses?.data.map((status) => (
              <DashboardCard
                key={status.id}
                user={user}
                isLoggedIn={isLoggedIn}
                status={status}
              />
            ))}
          </Container>
        </>
      ) : null}
    </>
  );
};

export default Dashboard;
